import { STORE, CLEAR, REFETCH_USER } from './constants';

export interface StoreAction {
  type: typeof STORE;
  token: string;
}

export const storeAction = (token: string): StoreAction => ({
  type: STORE,
  token,
});

export const clearAction = () => ({
  type: CLEAR,
});

// Used to refetch user info after update
export const refetchUserAction = () => ({ type: REFETCH_USER });
